import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useSessionRating(filters) {
  const initialState = {
    5: { count: 0, percent: 0 },
    4: { count: 0, percent: 0 },
    3: { count: 0, percent: 0 },
  };
  const [data, setData] = useState(initialState);
  const [loading, setLoading] = useState(false);

  const params = {
    policy_plan_id: filters.policyPlanId,
    team_id: filters.teamId,
    cycle_id: filters.cycleId,
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(routes.api.managers.dashboard.session_rating, { params })
      .then((response) => {
        setData(response.data.data);
        setLoading(false);
      });
  }, [filters.policyPlanId, filters.teamId, filters.cycleId]);

  return { data, loading };
}
